import { useEffect } from "react";

const EVENT = "hocp:stay-checked-out";

/** Fired by CheckoutFlow after a successful checkout so boards refresh without a reload. */
export const emitStayCheckedOut = (detail) => window.dispatchEvent(new CustomEvent(EVENT, { detail }));

export function useStayCheckedOut(callback) {
  useEffect(() => {
    const h = (e) => callback?.(e.detail);
    window.addEventListener(EVENT, h);
    return () => window.removeEventListener(EVENT, h);
  }, [callback]);
}
